import { Reveal, Eyebrow } from "@/components/Reveal";

const STEPS = [
  { title: "Tell Us About Your Business", body: "Complete the business intake form." },
  { title: "Assess", body: "We review your current digital position and objectives." },
  { title: "Recommend", body: "You receive recommended priorities based on the agreed scope." },
  { title: "Approve", body: "You decide which services, if any, you want to purchase." },
  { title: "Build", body: "Approved work enters the implementation process." },
  { title: "Measure", body: "Where applicable, analytics and performance indicators are reviewed." },
  {
    title: "Grow & Scale",
    body: "Successful systems can be expanded, automated, or integrated into a larger marketing operation.",
  },
];

export const Process = () => (
  <section className="relative py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <Reveal>
          <Eyebrow>How It Works</Eyebrow>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mt-4">
            Our Process
          </h2>
          <p className="text-slate-400 mt-4 leading-relaxed">
            A transparent path from first conversation to a growing, measurable system.
          </p>
        </Reveal>
      </div>

      <div className="lg:col-span-8 relative">
        <div className="absolute left-[19px] top-2 bottom-2 w-px bg-gradient-to-b from-gold/60 via-slate-700 to-emerald-500/50" />
        <div className="space-y-8">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={Math.min(i * 0.05, 0.25)}>
              <div className="relative flex gap-6 pl-1" data-testid={`process-step-${i + 1}`}>
                <span className="relative z-10 flex items-center justify-center w-10 h-10 rounded-full border border-gold/50 bg-obsidian font-display font-bold text-gold text-sm shrink-0">
                  {i + 1}
                </span>
                <div className="pt-1.5">
                  <h3 className="font-display font-bold text-white">{s.title}</h3>
                  <p className="text-slate-400 text-sm mt-1">{s.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Process;
